import FrontEndModel from './FrontEndModel';
import { formatDate } from './modelHelpers';
import User from './User';

export default class UpdatesForApproval extends FrontEndModel {
  constructor(data) {
    super(data);
    this.type = 'updatesForApproval';
    this.creator = new User(data.creator);
    this.reviewer = new User(data.reviewer);
  }

  createdAtStringLong() {
    return formatDate(new Date(Date.parse(this.createdAt)));
  }

  updatedAtStringLong() {
    return formatDate(new Date(Date.parse(this.updatedAt)));
  }
}
